module.exports = __webpack_public_path__ + "img/mgTV@2X.b8fcce3b.png";